import React from 'react';

import Feedback from '@xingternal/malt-feedback';

import ErrorContext from './ErrorContext';
import styles from './styles.css';

type ErrorMessageProps = {
  onClick: () => void;
};

const ErrorMessage = ({ onClick }: ErrorMessageProps) => (
  <ErrorContext.Consumer>
    {({ message, show }) => (
      <Feedback className={styles.feedback} show={show} onCancel={onClick}>
        {message}
      </Feedback>
    )}
  </ErrorContext.Consumer>
);

export default ErrorMessage;
